module.exports = __webpack_public_path__ + "img/Mobile_Home_33.83d83c7c.png";